import { useState } from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../utils/config";

function ForgotPassword() {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/forgotPassword`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) throw new Error("Failed to send reset email");

      window.location.href = `/reset-password?email=${email}`;
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Forgot Password</h2>

        <form onSubmit={handleSubmit}>
          <input type="text" name="email" placeholder="Enter your email" required />

          <button type="submit" style={{ marginTop: "10px" }}>
            {loading ? "Sending..." : "Send Reset Email"}
          </button>
        </form>

        <p><Link to="/login">Back to login</Link></p>
      </div>
    </div>
  );
}

export default ForgotPassword;
